import { ButtonSolidProps } from "./types"
import React from "react"
import { ButtonCore } from "./core"

const ButtonSolid: React.FC<ButtonSolidProps> = (props) => {
  return <ButtonCore {...props} type="solid"></ButtonCore>
}

export default ButtonSolid
